import React from 'react'
import TabMenu from '../../../components/TabMenu/TabMenu'
import { Outlet, Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { currentUserSelector } from '../../../store/selectors/userSelector'
import { useModal } from '../../../components/useModal'
import { useLocation, useNavigate, useParams } from 'react-router'
import { useGetUserById } from '../../../api/user/useGetUserById'
import { formatNumber } from '../../../lib/utils/formatNumber'
import { Button, PageHeader } from '@demandlocal/components'
import EditProfile from './EditProfile'
import MyProfile from './MyProfile'

function UserRouteTemplate(): JSX.Element {
  const currentUser = useSelector(currentUserSelector)
  const navigate = useNavigate()
  const { handleModal } = useModal()

  const params = useParams()
  const { data: user } = useGetUserById(params?.user_id || currentUser?.id)
  return (
    <div className={'flex flex-1 flex-col font-Spartan'}>
      <PageHeader
        cardsOptions={[
          {
            title: 'Associated agencies',
            content: formatNumber(user?.organizations?.length ?? 0),
            color: 'bg-chrysler-blue/20',
          },
          {
            title: 'Associated dealerships',
            content: formatNumber(user?.dealerships?.length ?? 0),
            color: 'bg-secondary-sunglow/20',
          },
        ]}
        title={`${user?.first_name ?? ''} ${user?.last_name ?? ''}`}
        rightSlot={() => (
          <Button onClick={() => navigate('profile/edit')}>Edit profile</Button>
        )}
      />
      <div className={'flex flex-1 flex-col px-10 max-w-[1920px] mx-auto w-full'}>
        <div className={'mt-12 mb-10'}>
          <TabMenu
            options={[
              { name: 'Info', to: 'profile' },
              { name: 'Payment info', to: 'payment' },
            ]}
          />
        </div>
        <Outlet />
      </div>
    </div>
  )
}

export default function User() {
  return (
    <Routes>
      <Route element={<UserRouteTemplate />}>
        <Route path={'profile/*'}>
          <Route path={'*'} element={<MyProfile />}>
            <Route path={'edit/*'} element={<EditProfile />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  )
}
